// extracted by mini-css-extract-plugin
export var modal = "_fn-0";